import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const menuChildrenAnimation = [
  trigger('children', [
    state(
      'void',
      style({
        height: '0px',
        padding: '0px',
        opacity: 0,
      }),
    ),
    state(
      'hiddenAnimated',
      style({
        height: '0px',
        padding: '0px',
        opacity: 0,
      }),
    ),
    state(
      'visibleAnimated',
      style({
        height: '*',
      }),
    ),
    state(
      'visible',
      style({
        height: '*',
      }),
    ),
    state(
      'hidden',
      style({
        height: '0px',
        padding: '0px',
        opacity: 0,
      }),
    ),
    transition(
      'visibleAnimated => hiddenAnimated',
      animate('100ms cubic-bezier(0.86, 0, 0.07, 1)'),
    ),
    transition(
      'hiddenAnimated => visibleAnimated',
      animate('100ms cubic-bezier(0.86, 0, 0.07, 1)'),
    ),
    transition(
      'void => visibleAnimated, visibleAnimated => void',
      animate('100ms cubic-bezier(0.86, 0, 0.07, 1)'),
    ),
  ]),
];
